import { lazy, Suspense } from 'react';
import PriceHead from './PriceHead'
import PricingLaunch from './PricingLaunch'

const PricingSearvices = lazy(() => import("./PricingSearvices"));
const PricePartnership = lazy(() => import("./PricePartnership"));
const HomeTestimonial = lazy(() => import("../Home/HomeTestimonial"));
const PriceContact = lazy(() => import("./PriceContact"));
const PriceBusiness = lazy(() => import("./PriceBusiness"));
const PriceManager = lazy(() => import("./PriceManager"));
const PriceFaqs = lazy(() => import("./PriceFaqs"));

const headText = ["Our Client ", <span className="gradiant-color">Testimonials</span>]

export default function Pricing() {

  return (
    <>
      <PriceHead />
      <PricingLaunch />

      <Suspense fallback={null}>
        <PriceBusiness />
        <PricingSearvices />
        <PriceManager />
        <PricePartnership />
        <HomeTestimonial headText={headText} />
        <PriceFaqs />
        <PriceContact />
      </Suspense>
    </>
  )
}
